const baseUrl = "https://trxtraining.inspire360.com/api.v3"
const limit = 250
const postalCode = document.getElementById('zip')?.value || ''
const now = new Date();
const startsAfter = now.toISOString()

function getMatchingProduct(workshopExternalId) {
  return products.find(product => product.variants[0].sku.toLowerCase() === workshopExternalId.toLowerCase())
}

function sortCoursesByDate(courses) {
  const list = Object.fromEntries(
    Object.entries(courses).sort(([,a],[,b]) => new Date(a.startTime) - new Date(b.startTime))
  );

  return list
}

function reduceCourses(courses) {
  const searchSkus = productSKUs.map(sku => sku.toLowerCase())
  return Object.fromEntries(
    Object.entries(courses).filter(([key, course]) => {
      return searchSkus.includes(course.workshopExternalId.toLowerCase())
    })
  )
}

function parseCourseDate(dates, isShort) {
  const dateLong = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })

  const dateShort = new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  })

  const makeTime = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  })

  const makeZone = new Intl.DateTimeFormat('en-US', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timeZoneName: 'short'
  })

  const makeDate = isShort ? dateShort : dateLong

  const day = makeDate.format(new Date(dates.start))
  const startTime = makeTime.format(new Date(dates.start))
  const endTime = makeTime.format(new Date(dates.end))
  const timeZoneDate = makeZone.formatToParts(new Date(dates.end))
  const zone = timeZoneDate.find(part => part.type === "timeZoneName");
  const time = `${startTime} - ${endTime} ${zone.value}`
  return { day, time }
}

async function getProducts(path, singleProduct) {
  let response = await fetch(path)
  if (!response.ok) {
    const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }
  response = await response.json()
  response = await singleProduct ? response.product : response.products
  if (typeof loadingProducts !== 'undefined') loadingProducts = false
  return response
}

async function fetchCourses() {
  let response = await fetch(`${baseUrl}/workshops/instances?status=Active&startsAfter=${startsAfter}&location=${postalCode}&limit=${limit}`)

  console.log({ response });

  if (!response.ok) {
    const message = `An error has occurred fetching courses: ${response.status}`;
    logDatadog(`courses.js error; fetchCourses error; An error has occurred fetching courses: ${response.status}`);
    throw new Error(message);
  }
  response = await response.json()

  console.log({ response });

  response = await response.items

  console.log({ response, 'response.length': response.length });

  if (response.length < 3) {
    logDatadog(`courses.js error; fetchCourses error; response.length: ${response.length}`)
  }

  logDatadog(`fetchCourses response.length: ${response.length}`);

  response = sortCoursesByDate(response)
  response = reduceCourses(response)
  return response
}

async function fetchCourse(externalId) {
  let response = await fetch(`${baseUrl}/workshops/instances/?externalId=${externalId}`)
  if (!response.ok) {
    const message = `An error has occurred fetching course: ${response.status}`;
    throw new Error(message);
  }
  response = await response.json()
  response = await response.items
  return response
}
